module.exports = __webpack_public_path__ + "media/images/member-icon-62f0b2fc6af9b1c730b209d5100d1113.svg";